<template>
	<div class="emoji-picker">
		<div v-for="(emojiGroup, category) in filteredEmojis" :key="category">
			<SubMenuTitle v-if="emojiGroup.length" :title="category" class="title-container" />
			<div class="emojis">
				<span v-for="emoji in emojiGroup" :key="emoji.name" @click="selectEmoji(emoji)" :title="emoji.name">
					{{ emoji.emoji }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
const EMOJIS = require('emojilib');
import emojisMetaDataByGroup from 'unicode-emoji-json/data-by-group.json';
import SubMenuTitle from '@/components/DataInput/DataInputMenu/SubMenuTitle';
export default {
	name: 'InsertDataEmojiPicker',
	props: {
		searchString: { type: String, default: '' },
	},
	components: {
		SubMenuTitle,
	},
	computed: {
		filteredEmojis() {
			return Object.fromEntries(
				Object.entries(this.enrichedEmojies).map(([groupName, emojiGroup]) => [
					groupName,
					emojiGroup.filter((emojiObj) => this.isSearchMatchingEmojiKeyWords(emojiObj.searchKeyWords)),
				])
			);
		},
	},
	methods: {
		isSearchMatchingEmojiKeyWords(emojiKeyWords = []) {
			return emojiKeyWords.some((word) => word.toLowerCase().includes(this.searchString.toLowerCase()));
		},
		selectEmoji(emoji) {
			this.$emit('select-emoji', emoji.emoji);
		},
		enrichEmoji(emojiObj, searchKeyWords = []) {
			return { ...emojiObj, searchKeyWords };
		},
	},
	mounted() {
		this.enrichedEmojies = Object.fromEntries(
			Object.entries(emojisMetaDataByGroup).map(([groupName, emojiGroup]) => [
				groupName,
				emojiGroup.map((emojiObj) => this.enrichEmoji(emojiObj, EMOJIS[emojiObj.emoji])),
			])
		);
		delete this.enrichedEmojies.Flags; // we remove the flags because Microsoft doesn't support it
	},
	data() {
		return {
			enrichedEmojies: {},
		};
	},
};
</script>
<style lang="scss">
.emoji-picker .emojis {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.emoji-picker .emojis:after {
	content: '';
	flex: auto;
}
.emoji-picker .emojis span {
	padding: 0.2rem;
	cursor: pointer;
	border-radius: 5px;
}
.emoji-picker .emojis span:hover {
	background: #ececec;
	cursor: pointer;
}
</style>
